import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { apiSetGuestPhoto } from '../../core/redux/api/endpoints';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import * as R from 'ramda';
import { GuestDetails } from '../guestDetails';
import { updateGuest } from '../module';


const KEY_ACTION = ACTION_TYPE.SET_GUEST_PHOTO_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.SET_GUEST_PHOTO_REQUEST,
  ACTION_TYPE.SET_GUEST_PHOTO_RESPONSE,
  ACTION_TYPE.SET_GUEST_PHOTO_ERROR,
];


export const setGuestPhotoAction = (guest: GuestDetails, base64Image: string) => makeApiAction(
  {
    method:   'POST',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: state => apiSetGuestPhoto(guest.masterGuestId, state.userState.userId, state.selectedResort.resortAbbreviation),
    body:     `"${base64Image}"`,
    types:    ACTIONS.map(action => ({ type: action, meta: { guest } })) as RsaaTypes,
    bailout:  state => !!getLoading(state, guest.masterGuestId, KEY_ACTION)
                       || hasTrippedBreaker(state, KEY_ACTION)
                       || base64Image === R.path([ 'photo', 'base64Img' ], state.guests.get(guest.masterGuestId)),
  },
);


const reducer: ApiReducer<string> = (state, action, error, isLoading, payload) => {
  const metaGuest = action.meta.guest;
  const guestId   = metaGuest.masterGuestId;

  if (isLoading) {
    return addLoading(state, guestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error, { guest: metaGuest });
  }

  // Remove loading/error since we're not loading or erroring - reset circuit breaker; a success happened
  const noErrorLoading = removeLoadingAndError(withBreaker, guestId, KEY_ACTION);

  return updateGuest(
    noErrorLoading,
    guestId,
    (guest: GuestDetails) => R.assocPath(
      [ 'photo', 'imgSmall' ],
      payload,
      R.assocPath([ 'photo', 'imgLarge' ], payload, guest),
    ),
  );
};


export const setGuestPhotoReducer = makeApiReducer<string>(ACTIONS, KEY_ACTION, reducer);
